<template>
  <div class="ContentTop">
    <div class="ContentTop-tabs">
      <a class="ContentTop-tab"
         :class="{active: activeKey===1}"
         href="/">Supernodes</a>
      <a class="ContentTop-tab" :class="{active: activeKey===2}" href="/blacklist"  style="width: 320px">Black List</a>
      <a class="ContentTop-tab" :class="{active: activeKey===3}" target="_blank"  style="width: 321px" href="https://goo.gl/forms/YflgbnVPuNTQDI8y1">File a Complaint</a>

      <el-input placeholder="Search by node name or address"
              suffix-icon="el-icon-search"
              style="width: 279px"
              v-model="input"
              @input="searchList"
              :disabled="!this.$store.state.nodes.effReady && this.$router.currentRoute.path==='/'"
      ></el-input>
    </div>
  </div>
</template>

<script>
  let t;
  export default {
    name: 'ContentTop',
    props: {
      activeKey: Number,
    },
    data() {
      return { input: '' };
    },
    methods: {
      searchList() {
        const that = this;
        this.$emit('searchData', that.input);
        // clearTimeout(t);
        // t = setTimeout(() => {
        //   this.$emit('searchData', that.input);
        // }, 300);
      },
    },
  };
</script>

<style lang="scss">
  .ContentTop {
    display: flex;
    justify-content: space-between;
    // a {
    //   color: #FF8737;
    // }
    &-tabs {
      display: flex;
      // font-weight: bold;
      height: 60px;
    }
    &-tab {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 300px;
      text-align: center;
      word-wrap: break-word;
      border: 1px solid #F2F2F5;
      cursor: pointer;
      line-height: 1.2;
      white-space: nowrap;
      font-size: 17px;
      color: #323233;
      box-sizing: border-box;
      border-bottom: none;
    }
    &-tab + &-tab {
      border-left: none;
    }
    &-tab:nth-child(3){
      border-right: none;
    }
    &-tab.active, &-tab:hover {
      color: #FF8837;
    }
    &-tab.active {
      border-bottom: none;
      border-top: 2px solid #FF8837;
    }
    input {
      border: 1px solid #F2F2F5;
      border-bottom: none;
      border-radius: 0;
      height: 60px;
    }
    .el-input__icon{
      font-size: 20px;
      line-height: 60px;
      width: 30px;
    }
    .el-input__inner:focus{
      border: 1px solid #FF8837;
    }
  }
</style>
